import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { checkTextTranslation, checkTranslation, imageAddress, translate } from "../../utils/useful";
import * as actions from "../../stores/actionsList"
import HttpServices from "../../utils/Http.services";
import moment from "moment/moment";
import TextAreaInput from "../inputs/TextAreaInput";
import ButtonAnimated from "../buttons/ButtonAnimated";


class MyRequests extends Component {
    state = {
        connections: {},
        tempMessage: {
            addRelation: 'wants to invite you to groups',
            newTask: 'assigned you to their task',
        }
    }
    componentDidMount() {
        let updates = this.props.connection.connections
        let connections = {}
        for (let i = 0; i < updates.length; i++) {
            if (!connections[updates[i]?.appletHub?.name]) {
                connections[updates[i]?.appletHub?.name] = []
            }
            connections[updates[i]?.appletHub?.name].push(updates[i])
        }
        this.setState({ connections: connections })
    }
    changeMessage = (key, value) => {
        let message = value
        this.setState({ message })
    }
    renderConnectionRequest = (item) => {
        return (
            <div className=" py-2 mb-3 w-100" style={{ transition: 'all 0.5s', }}>
                <div className="mb-3 flexcc" style={{ alignItems: 'flex-start' }}>
                    {/* <div className="" style={{}}> */}
                    <button onClick={() => { this.props.addNewWindow("hub", { path: [item.sender.username], type: 'hub' }, "center") }}>
                        <img className="mr-2" src={imageAddress(item?.sender?.image, 'profile')} style={{ width: '40px', height: 40, borderRadius: 40, objectFit: 'cover' }} />
                    </button>
                    <div>
                        <p className="font-size-14" style={{ cursor: 'default' }}><span className="weight-600" style={{}}>{item?.sender?.fullname}</span> {item.message ? checkTranslation(item.message) : translate('invite you to')} <span className="weight-600" style={{}}>{item.applet?.name}</span></p>
                        {/* <p className="text-small pb-1" style={{ fontWeight: 'bold' }}>{item.extra.type}</p>
                        <p className="text-smaller">{moment(item.cDate).format('DD MMMM YYYY')}</p>
                        <p className="text-smaller" style={{ cursor: 'pointer' }}>view more...</p> */}
                    </div>
                    {/* </div> */}
                </div>

                <div className="flexce">
                    <div className="flexc mrd-2">
                        <ButtonAnimated
                            onClick={() => this.handleRequest(item, false)}
                            title={translate('Decline')}
                            textColor={'#777'}
                            bg={'#e0e0e0'}
                            width={'100%'}
                        />
                    </div>
                    <div className="flexc">
                        <ButtonAnimated
                            iconwidth='24px'
                            onClick={() => this.handleRequest(item, true)}
                            title={translate('Accept')}
                            icon='/assets/icons/check-white.svg'
                            textColor={'#fff'}
                            bg={this.props.background ?? ' linear-gradient(90deg, #3062D4, #3062D4)'}
                            width={'100%'}
                        />
                    </div>
                    {/* <button className="w-100 flexcc mr-1 br-6 " style={{ padding: '6px 2px 6px 2px', maxWidth: '70px', background: '#3062D4', color: '#fff', cursor: 'pointer' }} onClick={() => this.handleRequest(item, true)}>
                        <p style={{ color: '#fff' }}>Accept</p>
                    </button>
                    <button className="w-100 flexcc ml-1 br-6 px-1" style={{ padding: '4px 2px 4px 2px', border: '1px solid #D3D9DE', maxWidth: '60px', background: '#fff', cursor: 'pointer' }} onClick={() => this.handleRequest(item, false)}>
                        <p style={{ color: '#000' }}>Deny</p>
                    </button> */}
                </div>
            </div>
        )
    }

    renderTaskRequest = (item) => {
        return (
            <div className=" py-3 px-2 my-2 w-100 br-8" style={{ transition: 'all 0.5s', borderBottom: '1px solid rgb(246, 246, 246)', backgroundColor: '#efefef' }}>
                <div className="mb-3 flexcc">
                    <img className="mr-2" src={imageAddress(item.hub?.image, 'profile')} style={{ width: '40px', height: 40, borderRadius: 40, objectFit: 'cover' }} />
                    <div>
                        <p className="text-small pb-1" style={{ fontWeight: 'bold' }}>{item.extra.type}</p>
                        <p className="text-small"><span style={{ fontWeight: 'bold' }}>{item?.sender?.fullname}</span> assigned you to <span style={{ fontWeight: 'bold' }}>{item.task.title}</span> task</p>
                        <p className="text-smaller">{moment(item.cDate).format('DD MMMM YYYY')}</p>
                        <p className="text-smaller" style={{ cursor: 'pointer' }}>view more...</p>
                    </div>
                </div>
                <div>
                    <TextAreaInput changeValue={this.changeMessage} data={checkTranslation(this.state.message)} header={{ key: 'message', information: { rows: 3, placeholder: '{{lang}}message' }, required: true }} />
                </div>
                <div className="w-100 flexc">
                    <div className="flexc mrd-2 w-50">
                        <ButtonAnimated
                            onClick={() => this.handleRequest(item, false)}
                            title={translate('Deny')}
                            textColor={'#a3a2b0'}
                            bg={'#eee'}
                            width={'100%'}
                        />
                    </div>
                    <div className="flexc mld-2 w-50">
                        <ButtonAnimated
                            iconwidth='24px'
                            onClick={() => this.handleRequest(item, true)}
                            title={translate('Accept')}
                            icon='/assets/icons/check-white.svg'
                            textColor={'#fff'}
                            bg={this.props.background ?? ' linear-gradient(90deg, #3062D4, #3062D4)'}
                            width={'100%'}
                        />
                    </div>
                    {/* <button className="w-100 flexcc ml-1 br-6 px-1" style={{ padding: '4px 2px 4px 2px', border: '1px solid #D3D9DE', maxWidth: '60px', background: '#fff', cursor: 'pointer' }} onClick={() => this.handleRequest(item, false)}>
                        <p style={{ color: '#000' }}>Deny</p>
                    </button>
                    <button className="w-100 flexcc mr-1 br-6 " style={{ padding: '6px 2px 6px 2px', maxWidth: '70px', background: '#3062D4', color: '#fff', cursor: 'pointer' }} onClick={() => this.handleRequest(item, true)}>
                        <p style={{ color: '#fff' }}>Accept</p>
                    </button> */}
                </div>
            </div>
        )
    }
    renderGroupRequest = (item) => {
        return (
            <div className=" py-2 mb-3 w-100" style={{ transition: 'all 0.5s', borderBottom: '1px solid #eee' }}>
                <div className="mb-3 flexc" style={{ alignItems: 'flex-start' }}>
                    {/* <div className="" style={{}}> */}
                    <button className="p-0 flexcc mrd-3 mt-1" onClick={() => { this.props.addNewWindow("hub", { path: [item.sender.username], type: 'hub' }, "center") }}>
                        <img src={imageAddress(item?.sender?.image, 'profile')} style={{ width: 30, height: 30, borderRadius: 30, objectFit: 'cover' }} alt="" />
                    </button>
                    <div className="">
                        <button className="p-0" onClick={() => { this.props.addNewWindow("hub", { path: [item.sender.username], type: 'hub' }, "center") }}>
                            <p className="font-size-15 main-c2 weight-600 ">{item.sender?.fullname}</p>
                        </button>
                        <p className="font-size-14 main-c2 weight-500  ">{translate("Sent you an invitation to connect to their hub")}</p>
                        {Array.isArray(item.groups) && item.groups.length > 0 && (
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <p className="text-small mrd-2">{translate("Groups")}: </p>
                                {item.groups.map((element, index) => {
                                    return (
                                        <div key={index} className="mrd-2">
                                            <div className="br-20  " >
                                                <p className="text-small">{element.name}{index < item.groups.length - 1 ? ', ' : ''}</p>
                                            </div>
                                        </div>
                                    )
                                })}
                                {/* <p className="font-size-14" style={{ cursor: 'default' }}><span className="weight-600" style={{}}>{item?.sender?.fullname}</span> {item.message ? checkTranslation(item.message) : translate('invite you to')} <span className="weight-600" style={{}}>{item.applet.name}</span></p> */}
                                {/* <p className="text-small pb-1" style={{ fontWeight: 'bold' }}>{item.extra.type}</p>
                                    <p className="text-smaller">{moment(item.cDate).format('DD MMMM YYYY')}</p>
                                <p className="text-smaller" style={{ cursor: 'pointer' }}>view more...</p> */}
                            </div>
                        )}
                    </div>
                    {/* </div> */}
                </div>

                <div className="flexce">
                    <div className="flexc mrd-2">
                        <ButtonAnimated
                            onClick={() => this.handleRequest(item, false)}
                            title={translate('Deny')}
                            textColor={'#a3a2b0'}
                            bg={'#e2e2e2'}
                            width={'100%'}
                        />
                    </div>
                    <div className="flexc">
                        <ButtonAnimated
                            iconwidth='24px'
                            onClick={() => this.handleRequest(item, true)}
                            title={translate('Accept')}
                            icon='/assets/icons/check-white.svg'
                            textColor={'#fff'}
                            bg={this.props.background ?? ' linear-gradient(90deg, #3062D4, #3062D4)'}
                            width={'100%'}
                        />
                    </div>
                    {/* <button className="w-100 flexcc mr-1 br-6 " style={{ padding: '6px 2px 6px 2px', maxWidth: '70px', background: '#3062D4', color: '#fff', cursor: 'pointer' }} onClick={() => this.handleRequest(item, true)}>
                        <p style={{ color: '#fff' }}>Accept</p>
                    </button>
                    <button className="w-100 flexcc ml-1 br-6 px-1" style={{ padding: '4px 2px 4px 2px', border: '1px solid #D3D9DE', maxWidth: '60px', background: '#fff', cursor: 'pointer' }} onClick={() => this.handleRequest(item, false)}>
                        <p style={{ color: '#000' }}>Deny</p>
                    </button> */}
                </div>
            </div>
        )
    }
    renderRequest = (item) => {
        switch (item.section) {
            case 'Tasking': {
                return this.renderTaskRequest(item)
            }
            case 'Relation': {
                return this.renderGroupRequest(item)
            }
            case 'Connection': {
                return this.renderConnectionRequest(item)
            }

        }

    }
    handleRequest = (item, accept) => {
        switch (item.extra.type) {
            case 'addRelation': {
                let data = { _id: item.extra._id, inbox: item._id, accept }
                HttpServices.request('handleInvitationRequest', data, (fetchResult, fetchError) => {
                    if (fetchError) {
                        return
                    }
                })
                break;
            }
            case 'newTask': {
                let data = { _id: item.extra._id, inbox: item._id, accept, message: this.state.message }
                HttpServices.request('handleTaskRequest', data, (fetchResult, fetchError) => {
                    if (fetchError) {
                        return
                    }
                })
            }
            case 'activeSprint': {
                let data = { _id: item.extra._id, inbox: item._id, accept, message: this.state.message }
                HttpServices.request('handleSprintTaskRequest', data, (fetchResult, fetchError) => {
                    if (fetchError) {
                        return
                    }
                })
            }
            case 'addCollection': {
                let data = { _id: item.extra._id, inbox: item._id, accept, message: this.state.message }
                HttpServices.request('confirmConnection', data, (fetchResult, fetchError) => {
                    if (fetchError) {
                        return
                    }
                })
            }
            default:
                break;
        }

        // 'updateTask'
    }
    render() {

        return (
            <div className="w-100 tower-body h-100 px-1" style={{ overflowX: 'hidden', left: 0, width: '100%', borderRadius: '0px' }} >
                <div className="w-100 sc-gray-mx tower-body py-3 h-100 px-1" style={{ overflowX: 'hidden', overflowY: 'auto', left: 0, width: '100%', borderRadius: '0px' }} >
                    <button className='px-1 flexc pb-2' onClick={() => this.props.changeStage('Home')} >
                        <div className="flexcc mrd-1" style={{}}>
                            <img src='/assets/icons/tower/arrow-left-gray.svg' width={'22px'} className='' style={{ cursor: 'pointer' }} />
                        </div>
                        <p className="font-size-16  text-semibold" style={{}}>{translate('Requests')}</p>
                    </button>
                    <div className="px-1 w-100">
                        {this.props.inbox.categorizer?.request?.list?.map((item) => {
                            return this.renderRequest(item)

                        })}
                    </div >
                </div >
            </div >
        )
    }
}
const mapStateToProps = (state) => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif, connection: state.connection, inbox: state.inbox });
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(MyRequests);